import PropTypes from 'prop-types';
var Container = PropTypes.shape({
  on: PropTypes.func,
  off: PropTypes.func,
  isHidden: PropTypes.bool,
  tab: PropTypes.shape({
    header: PropTypes.shape({
      tabs: PropTypes.arrayOf(PropTypes.shape({
        contentItem: PropTypes.shape({})
      }))
    })
  }),
  title: PropTypes.string,
  setTitle: PropTypes.func,
  close: PropTypes.func
});
var EventHub = PropTypes.shape({
  on: PropTypes.func,
  off: PropTypes.func,
  emit: PropTypes.func
});
var Layout = PropTypes.shape({
  registerComponent: PropTypes.func,
  root: PropTypes.shape({
    addChild: PropTypes.func
  }),
  on: PropTypes.func,
  off: PropTypes.func,
  eventHub: EventHub
});
var GLPropTypes = Object.freeze({
  Container,
  EventHub,
  Layout
});
export default GLPropTypes;
//# sourceMappingURL=GLPropTypes.js.map